module.exports = "../images/check.svg?v=ce7336b";